// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon___sl_K","conversationButton":"styles_conversationButton__27YLJ"};